export default "__VITE_ASSET__00f29be7__"